// extracted by mini-css-extract-plugin
module.exports = {"bar_options":"AbsenceNavigationBar_bar_options__1AT_h","vertical_divider":"AbsenceNavigationBar_vertical_divider__2dXT-"};